// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".appliedbid__container {\n  width: 100%;\n}\n.lookingbids {\n  margin-top: 6px;\n  margin-bottom: 60px;\n  color: var(--primary_color);\n}\n.lookingbids u {\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
